module.exports = new __parcel__URL__("near-wallet-icon.5e67d4a4.png").toString();